import { render, staticRenderFns } from "./EditAuthor.vue?vue&type=template&id=60628373&scoped=true&"
import script from "./EditAuthor.vue?vue&type=script&lang=js&"
export * from "./EditAuthor.vue?vue&type=script&lang=js&"
import style0 from "./EditAuthor.vue?vue&type=style&index=0&id=60628373&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60628373",
  null
  
)

export default component.exports